import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {
  Routes,
  Route,
  useLocation,
  useNavigate
} from "react-router-dom";
import './App.css';
import './rexma-alarmevent.css';
import './rexma-tagalarm.css';
import './validation.css';
// import './hmi-table.css';
import moment from 'moment'

import "@fontsource/inter/400.css"; // Specify weight
import "@fontsource/sarabun/400.css"; // Specify weight
import "@fontsource/sarabun/400-italic.css"; // Specify weight and style
import "@fontsource/sarabun/500.css"; // Specify weight
import "@fontsource/sarabun/500-italic.css"; // Specify weight and style
import "@fontsource/sarabun/600.css"; // Specify weight
import "@fontsource/sarabun/600-italic.css"; // Specify weight and style

import Navbar from './components/navbar/Navbar';

import LoginPage from './pages/Login';
import MeasurementPage from './pages/app_local/measurement/Measurement';
import AlarmEventPage from './pages/app_local/alarmevent/AlarmEvent';
import MainAdminPage from './pages/app_local/admin/MainAdmin';
import HistoricalDataPage from './pages/app_local/historical/HistoricalData';
import HistoricalReportPage from './pages/app_local/historical/HistoricalReport';
import MainReferencePage from './pages/app_local/reference/MainReference';
import DocumentPage from './pages/app_local/documents/Document';
import CCTVStreamingPage from './pages/app_local/cctv/CCTVStreaming';
import SiteInfoPage from './pages/app_local/plant/SiteInfo';

import Center_HistoricalCentralDataPage from './pages/app_center/historical/HistoricalCentralData';
import Center_HistoricalSiteDataPage from './pages/app_center/historical/HistoricalSiteData';
import Center_HistoricalSiteReportPage from './pages/app_center/historical/HistoricalSiteReport';
import Center_OverallPage from './pages/app_center/dashboard/Overall';
import Center_BusinessPage from './pages/app_center/dashboard/Business';
import Center_SiteHealthPage from './pages/app_center/dashboard/SiteHealth';
import Center_AlarmEventPage from './pages/app_center/alarmevent/AlarmEvent';
import Center_MainAdminPage from './pages/app_center/admin/MainAdmin';
import Center_MainReferencePage from './pages/app_center/reference/MainReference';
import Center_DocumentPage from './pages/app_center/documents/Document';

import ModalLoad from './components/modal/ModalLoad';
import ModalPopupMessage from './components/modal/ModalPopupMessage';

function App() {
  const location = useLocation();
  const navigate = useNavigate();

  const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
  const [modal_popup, setModal_popup] = useState({
    modaltype: '',
    headers: '',
    message: '',
    enable: false
  });
  const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

  const [data_systemdatetime, setData_Systemdatetime] = useState(moment(new Date()).format('DD MMM YYYY HH:mm:ss'));
  const [server_update, setServerUpdate] = useState(moment(new Date()).format("YYYY-MM-DD HH:mm:ss"))

  const center_app_key = useRef('');
  const [center_data_ok, setCenter_Data_ok] = useState(false);
  const [center_alarmcount_offline, setCenter_Alarmcount_offline] = useState(0);
  const [center_alarmcount_alarm, setCenter_Alarmcount_alarm] = useState(0);
  const [center_alarmcount_warning, setCenter_Alarmcount_warning] = useState(0);
  const [center_hot_update, setCenter_hot_update] = useState('-');

  const center_notify_ws = useRef(null);
  const [center_isConnectionOpen_notify, setCenter_IsConnectionOpen_notify] = useState(0);
  const [center_ui_api, setCenter_UI_api] = useState(0);
  const [center_ui_total_client, setCenter_ui_total_client] = useState(0);

  const local_app_key = useRef('');
  const [local_data_ok, setLocal_Data_ok] = useState(false);
  const [local_indicator, setLocal_Indicator] = useState({
    iot_restore_db_count: 0,
    power_limit: false,
  });
  const [local_commonstatus, setLocal_CommonStatus] = useState({
    center_chow_ok: false,
    center_cpf_ok: false,
    iot_device: true,
    alarmcount_alarm: 0,
    alarmcount_warning: 0,
    upgrading: false,
  });
  const local_notify_ws = useRef(null);
  const [local_isConnectionOpen_notify, setLocal_IsConnectionOpen_notify] = useState(0);
  const [local_ui_api, setLocal_UI_api] = useState(0);
  const [local_notify_trigger, setLocal_notify_trigger] = useState(true)

  const init_data = () => {
    return {
      chart_5m: {
        XLabel: '',
        Data: [],
        Summary: {},
        CODData: {},
        Summary_Unit: {},
      },
      chart_hour: {
        XLabel: '',
        Data: [],
        Summary: {},
        CODData: {},
        Summary_Unit: {},
      },
      chart_month: {
        XLabel: '',
        Data: [],
        Summary: {},
        CODData: {},
        Summary_Unit: {},
      },
      chart_year: {
        XLabel: '',
        Data: [],
        Summary: {},
        CODData: {},
        Summary_Unit: {},
      },
      chart_cod: {
        XLabel: '',
        Data: [],
        Summary: {},
        CODData: {},
        Summary_Unit: {},
      }
    }
  }
  const [data_chart, setData_chart] = useState(init_data());

  const [data_status_indicator, setData_status_indicator] = useState({})
  const [data_calculation, setData_calculation] = useState({})
  const [data_environment, setData_environment] = useState({})
  const [data_inverter, setData_inverter] = useState([])
  const [data_metergrid, setData_metergrid] = useState({})
  const [data_metersolar, setData_metersolar] = useState([])
  const [data_metersolar_total, setData_metersolar_total] = useState({})
  const [data_alarmevent_standing, setData_alarmevent_standing] = useState([])

  const [data_uioption, setData_uioption] = useState({});
  const system_update_current_Ref = useRef({
    update_uioption: '-',
    update_status_indicator: '-',
    update_environment: '-',
    update_inverter: '-',
    update_metergrid: '-',
    update_metersolar: '-',
    update_alarmevent_standing: '-',
    update_chart: '-'
  })

  const getLocalSessionObject = (session_name) => {
    const tokenString = sessionStorage.getItem(session_name);
    if (tokenString !== "undefined") {
      const userToken = JSON.parse(tokenString);
      return userToken
    }
    return {}
  };

  const getLocalSessionTokenString = (session_name) => {
    const tokenString = sessionStorage.getItem(session_name);
    if (tokenString !== "undefined") {
      const userToken = JSON.parse(tokenString);
      return userToken?.token
    }
    return null
  };

  const [token, setToken] = useState(getLocalSessionTokenString('cpfcenter-token4'));
  const [permitdata, setPermitdata] = useState(getLocalSessionObject('cpfcenter-token4'));

  const saveLocalSessionObject = (session_name, userToken) => {
    sessionStorage.setItem(session_name, JSON.stringify(userToken));
  };

  useEffect(() => {
    var tokenx = getLocalSessionTokenString('cpfcenter-token4')
    if (!tokenx) {
      if (location.pathname !== "/" && location.pathname !== "") {
        navigate('/');
      }
    }
    if (!location.pathname.includes("applocal")) {
      if (local_notify_ws.current !== null) {
        local_notify_ws.current.onopen = null
        local_notify_ws.current.onclose = null
        local_notify_ws.current.onmessage = null
        if (local_notify_ws.current.readyState === WebSocket.OPEN) {
          local_notify_ws.current.close()
        }
        local_notify_ws.current = null
      }
    }
  }, [location, token]);

  useEffect(() => {
    if (location.pathname === "/") {
      setData_chart(init_data())

      local_app_key.current = ""
      setLocal_Indicator({
        iot_restore_db_count: 0,
        power_limit: false,
      })
      setLocal_CommonStatus({
        center_chow_ok: false,
        center_cpf_ok: false,
        iot_device: true,
        alarmcount_alarm: 0,
        alarmcount_warning: 0,
        upgrading: false,
      })

      setData_status_indicator({})
      setData_calculation({})
      setData_environment({})
      setData_inverter([])
      setData_metergrid({})
      setData_metersolar([])
      setData_metersolar_total({})
      setData_alarmevent_standing([])
      setData_uioption({});
    }
  }, [location]);

  useEffect(() => {
    let timer_1s = null
    timer_1s = window.setInterval(() => {
      setData_Systemdatetime(moment(new Date()).format('DD MMM YYYY HH:mm:ss'))
    }, 1000);
    return () => {
      window.clearInterval(timer_1s)
    };
  }, []);

  function callback_signin(permit, config) {
    permit.back_url = ''
    if (permit.platform === 'local') {
      permit.proxy = ''
    }
    setData_uioption(config)
    setPermitdata(permit)
    setToken(permit.token);
    saveLocalSessionObject('cpfcenter-token4', permit)

    force_reset_updatestamp()

    if (permit.user_mode === "center") {
      navigate('/appcenter/dashboard/dboverall');
    } else if (permit.user_mode === "local") {
      navigate('/applocal/measurement/overview');
      setLocal_notify_trigger(true)
      setLocal_IsConnectionOpen_notify(0)
    }
  }

  function callback_signout(message) {
    force_signout()
  }

  async function api_realtime_local() {
    if (system_update_current_Ref.current.update_uioption === "" || system_update_current_Ref.current.update_uioption === "-") {
      setmodal_load({ enable: true, message: "Loading site configuration." })
      await sleep(300)
    }

    const formData = new FormData();
    formData.append("update_uioption", system_update_current_Ref.current.update_uioption)
    formData.append("update_status_indicator", system_update_current_Ref.current.update_status_indicator)
    formData.append("update_environment", system_update_current_Ref.current.update_environment)
    formData.append("update_inverter", system_update_current_Ref.current.update_inverter)
    formData.append("update_metergrid", system_update_current_Ref.current.update_metergrid)
    formData.append("update_metersolar", system_update_current_Ref.current.update_metersolar)
    formData.append("update_chart", system_update_current_Ref.current.update_chart)
    formData.append("update_alarmevent_standing", system_update_current_Ref.current.update_alarmevent_standing)

    axios.post(process.env.REACT_APP_API_URL + permitdata.proxy + "/api/measurement/realtimedata", formData, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data;',
        "Authorization": "Bearer " + permitdata.token
      },
    })
      .then((response) => {
        setmodal_load({ enable: false, message: "" })
        if (response.data.status === 'OK' && response.data.sitecode === permitdata.sitecode) {
          setServerUpdate(response.data.server_time)
          if (response.data.data_uioption !== undefined) {
            setData_uioption(response.data.data_uioption)
          }
          if (response.data.data_chart !== undefined) {
            setData_chart({
              ...data_chart,
              chart_5m: response.data.data_chart.data_chart_5m,
              chart_hour: response.data.data_chart.data_chart_hour,
              chart_month: response.data.data_chart.data_chart_month,
              chart_year: response.data.data_chart.data_chart_year,
              chart_cod: response.data.data_chart.data_chart_cod,
            })
            setData_calculation(response.data.data_chart.data_calculation)
          }
          if (response.data.commonstatus !== undefined) {
            setLocal_CommonStatus({
              center_chow_ok: response.data.commonstatus.center_chow_ok,
              center_cpf_ok: response.data.commonstatus.center_cpf_ok,
              iot_device: response.data.commonstatus.iot_device,
              alarmcount_alarm: response.data.commonstatus.alarmcount_alarm,
              alarmcount_warning: response.data.commonstatus.alarmcount_warning,
              upgrading: response.data.commonstatus.upgrading,
            })
          }
          if (response.data.data_status_indicator !== undefined) {
            setData_status_indicator(response.data.data_status_indicator)
            setLocal_Indicator({
              iot_restore_db_count: response.data.data_status_indicator.iot_restore_db_count,
              power_limit: response.data.data_status_indicator.power_limit,
            })
          }
          if (response.data.data_environment !== undefined) {
            setData_environment(response.data.data_environment)
          }
          if (response.data.data_inverter !== undefined) {
            setData_inverter(response.data.data_inverter)
          }
          if (response.data.data_metergrid !== undefined) {
            setData_metergrid(response.data.data_metergrid)
          }
          if (response.data.data_metersolar !== undefined) {
            setData_metersolar(response.data.data_metersolar)
          }
          if (response.data.data_alarmevent_standing !== undefined) {
            setData_alarmevent_standing(response.data.data_alarmevent_standing)
          }
          if (response.data.update_list !== undefined) {
            system_update_current_Ref.current = response.data.update_list
          }
          if (response.data.data_metersolar_total !== undefined) {
            setData_metersolar_total(response.data.data_metersolar_total)
          }
          setLocal_Data_ok(true)
        } else {
          setLocal_Data_ok(false)
        }
        setLocal_notify_trigger(false)
      })
      .catch((err) => {
        setmodal_load({ enable: false, message: "" })
        setLocal_notify_trigger(false)
        setLocal_Data_ok(false)
        if (system_update_current_Ref.current.update_uioption === "" || system_update_current_Ref.current.update_uioption === "-") {
          setModal_popup({
            modaltype: 'modal-error',
            headers: 'Error',
            message: "Can not load site configuration !.",
            enable: true
          });
        }
      });
  }

  useEffect(() => {
    if (local_notify_trigger === true) {
      if (permitdata !== null && permitdata !== undefined) {
        if (permitdata.token !== undefined) {
          if (permitdata.token !== "-" && permitdata.token !== "" && permitdata.view_mode === "local") {
            api_realtime_local()
          }
        }
      }
    }
  }, [permitdata, local_notify_trigger]);

  useEffect(() => {
    if (permitdata !== null && permitdata !== undefined && (local_isConnectionOpen_notify === 0 || local_isConnectionOpen_notify === 3)) {
      if (permitdata.token !== "" && permitdata.token !== "-" && permitdata.token !== undefined && permitdata.view_mode === "local") {
        local_notify_socket_connect()
      }
    }
  }, [permitdata, local_isConnectionOpen_notify]);

  useEffect(() => {
    if (permitdata !== null && permitdata !== undefined && (center_isConnectionOpen_notify === 0 || center_isConnectionOpen_notify === 3)) {
      if (permitdata.token !== "" && permitdata.token !== "-" && permitdata.token !== undefined && permitdata.user_mode === "center") {
        center_notify_socket_connect()
      }
    }
  }, [permitdata, center_isConnectionOpen_notify]);

  function local_notify_socket_connect() {
    if (local_notify_ws.current !== null) {
      local_notify_ws.current.onopen = null
      local_notify_ws.current.onclose = null
      local_notify_ws.current.onmessage = null
      if (local_notify_ws.current.readyState === WebSocket.OPEN) {
        local_notify_ws.current.close()
      }
      local_notify_ws.current = null
    }

    setLocal_IsConnectionOpen_notify(-1)

    local_notify_ws.current = new WebSocket(process.env.REACT_APP_API_URL + permitdata.proxy + "/api/measurement/socket/connect?username=" + permitdata.username + "&&token=" + permitdata.token);
    local_notify_ws.current.onopen = () => {
      console.log("Notify Socket Connection opened");
      setLocal_IsConnectionOpen_notify(2)
      setLocal_UI_api(2)
    };

    local_notify_ws.current.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data !== null && data !== undefined) {
        if (data.mode !== null && data.mode !== undefined) {
          if (data.mode === "change") {
            if (local_app_key.current !== data.app_key && local_app_key.current !== "") {
              console.log('Reload page')
              window.location.reload();
            } else {
              local_app_key.current = data.app_key
              setLocal_IsConnectionOpen_notify(2)
              setLocal_UI_api(2)
              setLocal_notify_trigger(true)
            }
          }
        }
      }
    };

    local_notify_ws.current.onclose = (event) => {
      console.log("Notify Socket Connection Lose");
      setLocal_Data_ok(false)
      setLocal_IsConnectionOpen_notify(3)
      setLocal_UI_api(3)
    };

    local_notify_ws.current.onerror = (event) => {
      console.log("Notify Socket Connection Error");
      setLocal_Data_ok(false)
      setLocal_IsConnectionOpen_notify(3)
      setLocal_UI_api(3)
    };
  }

  function center_notify_socket_connect() {
    if (center_notify_ws.current !== null) {
      center_notify_ws.current.onopen = null
      center_notify_ws.current.onclose = null
      center_notify_ws.current.onmessage = null
      if (center_notify_ws.current.readyState === WebSocket.OPEN) {
        center_notify_ws.current.close()
      }
      center_notify_ws.current = null
    }

    setCenter_IsConnectionOpen_notify(-1)

    center_notify_ws.current = new WebSocket(process.env.REACT_APP_API_URL + "/proxy/center/api/measurement/socket/connect?username=" + permitdata.username + "&&token=" + permitdata.token);
    center_notify_ws.current.onopen = () => {
      console.log("Center notify Socket Connection opened");
      setCenter_IsConnectionOpen_notify(2)
      setCenter_UI_api(2)
    };

    center_notify_ws.current.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data !== null && data !== undefined) {
        if (data.mode !== null && data.mode !== undefined) {
          if (data.mode === "change") {
            if (center_app_key.current !== data.app_key && center_app_key.current !== "") {
              console.log('Reload page')
              window.location.reload();
            } else {
              center_app_key.current = data.app_key
              setCenter_IsConnectionOpen_notify(2)
              setCenter_UI_api(2)
              setCenter_hot_update(data.hot_update)
              setCenter_Alarmcount_offline(data.count_offline)
              setCenter_Alarmcount_alarm(data.count_alarm)
              setCenter_Alarmcount_warning(data.count_warning)
              setCenter_Data_ok(true)
              setCenter_ui_total_client(data.total_client)
            }
          }
        }
      }
    };

    center_notify_ws.current.onclose = (event) => {
      console.log("Center notify Socket Connection Lose");
      setCenter_IsConnectionOpen_notify(3)
      setCenter_UI_api(3)
      setCenter_Data_ok(false)
    };

    center_notify_ws.current.onerror = (event) => {
      console.log("Center notify Socket Connection Error");
      setCenter_IsConnectionOpen_notify(3)
      setCenter_UI_api(3)
      setCenter_Data_ok(false)
    };
  }

  function callback_select_site(sitecode, sitename_en, sitename_th, api_url, back_url) {
    force_reset_updatestamp()

    const newstate = JSON.parse(JSON.stringify(permitdata))
    newstate.view_mode = "local"
    newstate.sitecode = sitecode
    newstate.sitename_en = sitename_en
    newstate.sitename_th = sitename_th
    newstate.proxy = api_url
    newstate.back_url = back_url

    saveLocalSessionObject('cpfcenter-token4', newstate)
    setPermitdata(newstate)

    navigate('/applocal/measurement/overview');
    setLocal_notify_trigger(true)
    setLocal_IsConnectionOpen_notify(0)
  }

  function callback_backcenter() {
    force_reset_updatestamp()

    const back_url = permitdata.back_url

    const newstate = JSON.parse(JSON.stringify(permitdata))
    newstate.view_mode = "center"
    newstate.sitecode = ""
    newstate.sitename_en = ""
    newstate.sitename_th = ""
    newstate.proxy = "/proxy/center"
    newstate.back_url = ""
    saveLocalSessionObject('cpfcenter-token4', newstate)
    setPermitdata(newstate)


    setData_chart(init_data())

    local_app_key.current = ""
    setLocal_Indicator({
      iot_restore_db_count: 0,
      power_limit: false,
    })
    setLocal_CommonStatus({
      center_chow_ok: false,
      center_cpf_ok: false,
      iot_device: true,
      alarmcount_alarm: 0,
      alarmcount_warning: 0,
      upgrading: false,
    })

    setData_status_indicator({})
    setData_calculation({})
    setData_environment({})
    setData_inverter([])
    setData_metergrid({})
    setData_metersolar([])
    setData_metersolar_total({})
    setData_alarmevent_standing([])
    setData_uioption({});

    navigate(back_url);
  }

  //rejected URL Sheating....
  useEffect(() => {
    if (permitdata !== null && permitdata !== undefined) {
      var reject_hook = false
      if (permitdata.platform === null || permitdata.platform === undefined) {
        reject_hook = true
      }
      if (permitdata.platform !== null && permitdata.platform !== undefined) {
        if (permitdata.platform === "") {
          reject_hook = true
        }
      }

      var reject_bypass = false
      if (permitdata.group_handle !== null && permitdata.group_handle !== undefined) {
        if (permitdata.group_handle[0] !== undefined) {
          var group_selected = ''
          if (location.pathname.includes("dbgroup/Feed")) {
            group_selected = "Feed"
          } else if (location.pathname.includes("dbgroup/Farm")) {
            group_selected = "Farm"
          } else if (location.pathname.includes("dbgroup/Food")) {
            group_selected = "Food"
          } else if (location.pathname.includes("dbgroup/Other")) {
            group_selected = "Other"
          }
          if (permitdata.group_handle.indexOf(group_selected) < 0 && group_selected !== '') {
            reject_bypass = true
          }
        }
      }

      if (permitdata.platform === null || permitdata.platform === undefined || reject_hook || reject_bypass ||
        (permitdata.user_mode === "local" && window.location.href.includes('appcenter'))) {
        force_signout()
      }
    }
  }, [location.pathname]);

  function force_signout() {
    var x = {
      id: '',
      username: '',
      password: '',
      status: '',
      user_role: '',
      firstname: '',
      lastname: '',
      cod_date: '',
      logintime: '',
      user_mode: '',
      view_mode: '',
      sitecode: '',
      sitescope_arr: [],
      sitescope_str: '',
      sitename_en: '',
      sitename_th: '',
      proxy: '',
      group_handle: [],
      back_url: '',
      platform: ''
    }
    setToken('');
    saveLocalSessionObject('cpfcenter-token4', x)
    setPermitdata(x)
    navigate('/');

    force_reset_updatestamp()
    local_app_key.current = ""
    setLocal_Indicator({
      iot_restore_db_count: 0,
      power_limit: false,
    })
    setLocal_CommonStatus({
      center_chow_ok: false,
      center_cpf_ok: false,
      iot_device: true,
      alarmcount_alarm: 0,
      alarmcount_warning: 0,
      upgrading: false,
    })

    setData_status_indicator({})
    setData_calculation({})
    setData_environment({})
    setData_inverter([])
    setData_metergrid({})
    setData_metersolar([])
    setData_metersolar_total({})
    setData_alarmevent_standing([])
    setData_uioption({});
  }

  function force_reset_updatestamp() {
    system_update_current_Ref.current = {
      update_uioption: '-',
      update_status_indicator: '-',
      update_environment: '-',
      update_inverter: '-',
      update_metergrid: '-',
      update_metersolar: '-',
      update_alarmevent_standing: '-',
      update_chart: '-'
    }
  }

  function PopupMsg_onGeneral(message) {
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false
    });
  }

  return (
    <div>
      {
        token ?
          <div id="mainroot" className="root mn--sticky hd--sticky hd--fair mn--min ">
            <Navbar
              callback_signout={message => { callback_signout(message) }}
              permitdata={permitdata}
              data_uioption={data_uioption}
              local_api_state={local_ui_api}
              local_data_ok={local_data_ok}
              local_indicator={local_indicator}
              local_commonstatus={local_commonstatus}
              center_api_state={center_ui_api}
              center_data_ok={center_data_ok}
              center_alarmcount_offline={center_alarmcount_offline}
              center_alarmcount_alarm={center_alarmcount_alarm}
              center_alarmcount_warning={center_alarmcount_warning}
              center_ui_total_client={center_ui_total_client}
            />
            <Routes>
              <Route
                path="/appcenter/dashboard/dboverall"
                element={<Center_OverallPage
                  permitdata={permitdata}
                  data_systemdatetime={data_systemdatetime}
                  center_hot_update={center_hot_update}
                />} />
              <Route
                path="/appcenter/dashboard/dbgroup/*"
                element={<Center_BusinessPage
                  permitdata={permitdata}
                  data_systemdatetime={data_systemdatetime}
                  center_hot_update={center_hot_update}
                  callback_select_site={(sitecode, sitename_en, sitename_th, api_url, back_url) => { callback_select_site(sitecode, sitename_en, sitename_th, api_url, back_url) }}
                />} />
              <Route
                path="/appcenter/dashboard/sitehealth"
                element={<Center_SiteHealthPage
                  permitdata={permitdata}
                  data_systemdatetime={data_systemdatetime}
                  center_hot_update={center_hot_update}
                  callback_select_site={(sitecode, sitename_en, sitename_th, api_url, back_url) => { callback_select_site(sitecode, sitename_en, sitename_th, api_url, back_url) }}
                />} />
              <Route
                path="/appcenter/alarmevent/*"
                element={<Center_AlarmEventPage
                  permitdata={permitdata}
                  data_alarmevent_standing={data_alarmevent_standing}
                  data_systemdatetime={data_systemdatetime}
                  server_update={server_update}
                  center_hot_update={center_hot_update}
                  callback_select_site={(sitecode, sitename_en, sitename_th, api_url, back_url) => { callback_select_site(sitecode, sitename_en, sitename_th, api_url, back_url) }}
                />} />
              <Route
                path="/appcenter/reference/*"
                element={<Center_MainReferencePage
                  permitdata={permitdata}
                  data_systemdatetime={data_systemdatetime}
                />} />
              <Route
                path="/appcenter/document"
                element={<Center_DocumentPage
                  permitdata={permitdata}
                  data_systemdatetime={data_systemdatetime}
                  callback_backcenter={() => { callback_backcenter() }}
                />} />
              <Route
                path="/appcenter/historical/historicaldashboard/*"
                element={<Center_HistoricalCentralDataPage
                  permitdata={permitdata}
                  data_systemdatetime={data_systemdatetime}
                  callback_backcenter={() => { callback_backcenter() }}
                />} />
              <Route
                path="/appcenter/historical/historicaldata/*"
                element={<Center_HistoricalSiteDataPage
                  permitdata={permitdata}
                  data_systemdatetime={data_systemdatetime}
                  callback_backcenter={() => { callback_backcenter() }}
                />} />
              <Route
                path="/appcenter/historical/report/*"
                element={<Center_HistoricalSiteReportPage
                  permitdata={permitdata}
                  data_systemdatetime={data_systemdatetime}
                />} />
              <Route
                path="/applocal/measurement/*"
                element={<MeasurementPage
                  permitdata={permitdata}
                  data_uioption={data_uioption}
                  data_status_indicator={data_status_indicator}
                  data_status_common={local_commonstatus}
                  data_calculation={data_calculation}
                  data_environment={data_environment}
                  data_inverter={data_inverter}
                  data_metergrid={data_metergrid}
                  data_metersolar={data_metersolar}
                  data_metersolar_total={data_metersolar_total}
                  data_chart={data_chart}
                  local_data_ok={local_data_ok}
                  data_systemdatetime={data_systemdatetime}
                  server_update={server_update}
                  local_api_state={local_ui_api}
                  callback_backcenter={() => { callback_backcenter() }}
                />} />
              <Route
                path="/applocal/cctv/streaming"
                element={<CCTVStreamingPage
                  permitdata={permitdata}
                  data_systemdatetime={data_systemdatetime}
                  data_uioption={data_uioption}
                  callback_backcenter={() => { callback_backcenter() }}
                />} />
              <Route
                path="/applocal/plant/siteinfo"
                element={<SiteInfoPage
                  permitdata={permitdata}
                  data_systemdatetime={data_systemdatetime}
                  data_uioption={data_uioption}
                  callback_backcenter={() => { callback_backcenter() }}
                />} />
              <Route
                path="/applocal/alarmevent/*"
                element={<AlarmEventPage
                  permitdata={permitdata}
                  data_uioption={data_uioption}
                  data_alarmevent_standing={data_alarmevent_standing}
                  data_systemdatetime={data_systemdatetime}
                  server_update={server_update}
                  callback_backcenter={() => { callback_backcenter() }}
                />} />
              <Route
                path="/applocal/historical/historicaldata/*"
                element={<HistoricalDataPage
                  permitdata={permitdata}
                  data_systemdatetime={data_systemdatetime}
                  data_uioption={data_uioption}
                  callback_backcenter={() => { callback_backcenter() }}
                />} />
              <Route
                path="/applocal/historical/report/*"
                element={<HistoricalReportPage
                  permitdata={permitdata}
                  data_systemdatetime={data_systemdatetime}
                  callback_backcenter={() => { callback_backcenter() }}
                />} />
              <Route
                path="/applocal/reference/*"
                element={<MainReferencePage
                  permitdata={permitdata}
                  data_systemdatetime={data_systemdatetime}
                  callback_backcenter={() => { callback_backcenter() }}
                />} />
              <Route
                path="/applocal/document"
                element={<DocumentPage
                  permitdata={permitdata}
                  data_systemdatetime={data_systemdatetime}
                  callback_backcenter={() => { callback_backcenter() }}
                />} />
              {
                permitdata !== undefined ?
                  permitdata.user_role === "Admin" ?
                    <Route
                      path="/applocal/adminconsole/*"
                      element={<MainAdminPage
                        permitdata={permitdata}
                        data_systemdatetime={data_systemdatetime}
                        data_uioption={data_uioption}
                        data_inverter={data_inverter}
                        callback_backcenter={() => { callback_backcenter() }}
                      />} />
                    :
                    null
                  : null
              }
              {
                permitdata !== undefined ?
                  permitdata.user_role === "Admin" ?
                    <Route
                      path="/appcenter/adminconsole/*"
                      element={<Center_MainAdminPage
                        permitdata={permitdata}
                        data_systemdatetime={data_systemdatetime}
                      />} />
                    :
                    null
                  : null
              }
            </Routes>
          </div>
          :
          <Routes>
            <Route exact path="" element={<LoginPage
              callback_signin={(permit, config) => {
                callback_signin(permit, config)
              }}
            />} />
            <Route exact path="/" element={<LoginPage
              callback_signin={(permit, config) => { callback_signin(permit, config) }}
            />} />
          </Routes>
      }
      {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
      {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onGeneral={msg => { PopupMsg_onGeneral(msg) }} /> : null}
    </div>
  );
}

export default App;
